/**
 * External Reference Authentication Constants
 *
 * URL parameter names for external reference authentication (nameId & source)
 */

export const EXTERNAL_REFERENCE_PARAMS = {
  /** Primary user identifier parameter */
  NAME_ID: 'nameId',
  /** External system source identifier parameter */
  SOURCE: 'source'
} as const;
